import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalClose,
  ModalDialog,
  Option,
  Select,
  Sheet,
  Typography,
} from '@mui/joy';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import { IOfferFilter } from '../interface/IOffer';

type Props = {
  filters: IOfferFilter;
  onFilterChange: (filter: keyof IOfferFilter, value: any) => void;
  onFilterReset?: () => void;
  onFilterApply?: () => void;
};

const OfferTableFilter = ({ filters, onFilterChange, onFilterApply, onFilterReset }: Props) => {
  const [open, setOpen] = React.useState(false);
  const renderFilters = () => (
    <React.Fragment>
      <FormControl size='sm'>
        <FormLabel>Create Date</FormLabel>
        <Input name='paymentMonth' value={filters.createDate ?? ''} type='date' onChange={e => onFilterChange('createDate', e.target.value)} />
      </FormControl>
      <FormControl size='sm'>
        <FormLabel>Status</FormLabel>
        <Select size='sm' placeholder='All' onChange={(e, value) => onFilterChange('status', value)} value={filters.status ?? null}>
          <Option value='all'>All</Option>
          <Option value='draft'>Draft</Option>
          <Option value='open'>Open</Option>
          <Option value='accepted'>Accepted</Option>
          <Option value='finished'>Finished</Option>
          <Option value='cancelled'>Cancelled</Option>
        </Select>
      </FormControl>
    </React.Fragment>
  );

  return (
    <div style={{ padding: 0, flex: 1 }}>
      <Sheet
        className='SearchAndFilters-mobile'
        sx={{
          display: { xs: 'flex', sm: 'none' },
          my: 1,
          gap: 1,
        }}
      >
        <Input
          size='sm'
          placeholder='Search'
          startDecorator={<SearchIcon />}
          sx={{ flexGrow: 1 }}
          value={filters.search ?? ''}
          onChange={e => onFilterChange('search', e.target.value)}
        />
        <IconButton size='sm' variant='outlined' color='neutral' onClick={() => setOpen(true)}>
          <FilterAltIcon />
        </IconButton>
        <Modal open={open} onClose={() => setOpen(false)}>
          <ModalDialog aria-labelledby='filter-modal' layout='fullscreen'>
            <ModalClose />
            <Typography id='filter-modal' level='h2'>
              Filters
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Sheet sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {renderFilters()}
              <Button color='primary' onClick={() => setOpen(false)}>
                Submit
              </Button>
            </Sheet>
          </ModalDialog>
        </Modal>
      </Sheet>
      <Box
        className='SearchAndFilters-tabletUp'
        sx={{
          borderRadius: 'sm',
          py: 0,
          display: { xs: 'none', sm: 'flex' },
          flexWrap: 'wrap',
          flex: 1,
          gap: 1.5,
          '& > *': {
            minWidth: { xs: '120px', md: '160px' },
          },
        }}
      >
        <FormControl sx={{ flex: 0.5 }} size='sm'>
          <FormLabel>Search for order</FormLabel>
          <Input
            size='sm'
            placeholder='Search'
            startDecorator={<SearchIcon />}
            value={filters.search ?? ''}
            onChange={e => onFilterChange('search', e.target.value)}
          />
        </FormControl>
        {renderFilters()}
        <Button variant='outlined' color='primary' size='sm' onClick={() => onFilterApply?.()} sx={{ alignSelf: 'end' }}>
          Filter
        </Button>
        <Button variant='outlined' color='neutral' size='sm' onClick={() => onFilterReset?.()} sx={{ alignSelf: 'end' }}>
          Reset Filters
        </Button>
      </Box>
    </div>
  );
};

export default OfferTableFilter;
